import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, DBRadioButton, ObjectiveFlag, DBDropDown, DBCheckBox, DBDecimalFieldObjective, DBCheckBoxRadioComment } from '_components';
import styles from './Common.module.css'

class SpeechFluency extends React.Component {

    render() {
        return (
          <div>
                
                <div className={styles.formRowSetting}>
                    {this.props.flagged ? <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Fluency' /> : <div className={styles.flag} / >}
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSFLUSTATUS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radioSpace}
                            />   
                            
                            
                            <div className={styles.underHeaderRadioSpace} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSFLUSTATUS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
 
                    </div>

                    <div className={styles.spanGap}>
                        <b>Comments</b>
                    </div>

                <div className={styles.formRowSetting}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUCOMMENTS'
                        className={styles.txtAreaGap}
                    />
                </div>

                <div className={styles.formRowSetting}>
                    {this.props.severityFlagged 
                    ? 
                    <ObjectiveFlag className={styles.flag} flagged={this.props.severityFlagged} flagText='Severity' /> : <div className={styles.flag}/>}
                        
                            
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUSEVERITY'
                        label='Severity'
                    />
                    <DBDropDown
                        field='OSFLUSEVERITYSTATUS'
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        className={styles.dropDown}
                        customOptions={
                            [
                                {id: 1, value: 'Very Mild'},
                                {id: 2, value: 'Mild'},
                                {id: 3, value: 'Moderate'},
                                {id: 4, value: 'Severe'},
                                {id: 5, value: 'Very Severe'}
                            ]
                        }
                    />
                </div>

                {this.props.severityFlagged 
                  ? (
                <div className={styles.formRow}>
                  <DBTextAreaObjective
                      noteId={this.props.noteId}
                      entity='PTOBJECTIVESPEECH'
                      entityKeyColumn='OSNO'
                      entityKeyValue={this.props.osno}
                      field='OSFLUSEVERITYTXT'
                      className={styles.txtAreaGap}
                  />
                </div>) :null}

                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSFLURATE'
                         className={styles.checkbox}
                         label='Rate of Speech'
                         textAreaStyle={styles.commentTextArea}
                         options={[{
                            id: 1,
                            label: 'Normal',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLURATESTATUS',
                            selectedValue: 'Normal',
                            type: 'bit'
                          },
                          {
                            id: 2,
                            label: 'Slow',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLURATESTATUS',
                            selectedValue: 'Slow',
                            type: 'bit'
                          },
                          {
                            id: 3,
                            label: 'Rapid',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLURATESTATUS',
                            selectedValue: 'Rapid',
                            type: 'bit'
                          }
                        ]}
                    />
                </div>


                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSFLUTYPE'
                         className={styles.checkbox}
                         label='Type of Disfluency'
                         textAreaStyle={styles.commentTextArea}
                         options={[{
                            id: 1,
                            label: 'Blocks',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLUTYPESTATUS',
                            selectedValue: 'Blocks',
                            type: 'bit'
                          },
                          {
                            id: 2,
                            label: 'Repetitions',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLUTYPESTATUS',
                            selectedValue: 'Repetitions',
                            type: 'bit',
                            style: {paddingLeft: '6px'}
                          },
                          {
                            id: 3,
                            label: 'Prolongations',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLUTYPESTATUS',
                            selectedValue: 'Prolongations',
                            type: 'bit',
                            style: {marginLeft: '-47px'}
                          }
                        ]}
                    />
                </div>

                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSFLUSECOND'
                         className={styles.checkbox}
                         label='Secondary Characteristics'
                         textAreaStyle={styles.commentTextArea}
                         options={[{
                            id: 1,
                            label: 'None',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLUSECONDSTATUS',
                            selectedValue: 'None',
                            type: 'bit',
                            showFlag: false,
                          },
                          {
                            id: 2,
                            label: 'Tension / Grimace',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLUSECONDSTATUS',
                            selectedValue: 'Tension / Grimace',
                            type: 'bit',
                            style: {paddingLeft: '15px'}
                          },
                          {
                            id: 3,
                            label: 'Other',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLUSECONDSTATUS',
                            selectedValue: 'Other',
                            type: 'bit',
                            style: {marginLeft: '-36px'}
                          }
                        ]}
                    />
                </div>

                <div className={styles.textFieldRow}>
                    <label>Total disfluencies: </label>
                    <span className={styles.radioSpace}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            field='OSFLUSCORE'
                            className={styles.circumInput}
                            min={0}
                        />
                    </span>
                    <label className={styles.radioSpace}>per</label>
                    <span className={styles.radioSpace}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            field='OSFLUTOTAL'
                            className={styles.circumInput}
                            min={0}
                        />
                    </span>
                </div>

      </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
        
    return {
        noteId: noteId,
        osno: osno,
        flagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSTATUS !== undefined 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSTATUS !== null 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSTATUS !== 'WNL'),
        severityFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSEVERITY !== undefined 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSEVERITY !== null 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSEVERITY)
    };
}

const connectedSpeechFluency = connect(mapStateToProps)(SpeechFluency);
export { connectedSpeechFluency as SpeechFluency };


